/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!*********************!*\
  !*** ./js/index.js ***!
  \*********************/
/***/ (function(module, exports) {

	/* global $, tns */
	/*
	 * Flash sale scripts
	 */
	(function() {
	  $(document).ready(function() {
	    var flashSaleTab = $('.js-flashSale__tab');
	    var flashSaleTabPanel = $('.js-flashSale__tabPanel');
	    var flashSaleDropDown = $('.js-flashSale__dropdown');
	    var flashSaleDropDownMenu = $('.js-flashSale__menu');
	    var flashSaleDropDownTrigger = $('.js-flashSale__dropdownTrigger');
	    var flashSaleMenuItem = $('.js-flashSale__menuItem');
	    var flashSaleShowMore = $('.js-showMoreButton');
	    var hash = window.location.hash.split('?')[0];
	    var currentOpenTab = $('.js-flashSale__tab[aria-selected="true"]');
	
	    function resetUrl() {
	      window.history.replaceState({}, document.title, window.location.pathname);
	    }
	
	    function resetTabs() {
	      // Reset Tabs
	      flashSaleTab.each(function(index, el) {
	        el.setAttribute('aria-selected', false);
	      });
	
	      // Reset TabPanels
	      flashSaleTabPanel.each(function(index, el) {
	        el.setAttribute('aria-hidden', true);
	      });
	    }
	
	    function toggleTab(tabPanel) {
	      resetTabs();
	
	      var selectedTab = document.querySelector('.js-flashSale__tab[aria-controls="'+ tabPanel +'"]');
	      var selectedTabPanel = document.querySelector('.js-flashSale__tabPanel[aria-labelledby="'+ tabPanel +'"]');
	
	      selectedTab.setAttribute('aria-selected', true);
	      selectedTabPanel.setAttribute('aria-hidden', false);
	    }
	
	    function initializeSliders() {
	      var sliders = document.querySelectorAll('.js-flashSale-mobileSlider');
	      var options = {
	        container: '',
	        items: 1,
	        autoplay: false,
	        nav: false,
	        slideBy: 1,
	        edgePadding: 40,
	        controls: false,
	        animateIn: true,
	        lazyload: true,
	        mouseDrag: true,
	        disable: false,
	        freezable: false,
	        responsive: {
	          600: {
	            disable: true
	          }
	        }
	      };
	
	      var trackUserSlide = function(info) {
	        var container = info.container.id.split('-');
	
	        $.trackEvent('Flash Sale', 'Mobile slider', 'User swipe ' + container[1]);
	      }
	
	      for (var i in sliders) {
	        if (sliders[i].id !== undefined) {
	          var sliderContainer = sliders[i].id;
	          options.container = '#' + sliderContainer;
	          var cardSlider = tns(options);
	
	          // bind function to event
	          cardSlider.events.on('transitionStart', trackUserSlide);
	        }
	      }
	    }
	
	    // First off, declare sliders
	    initializeSliders();
	
	    // Tabs
	    flashSaleTab.on('click', function() {
	      $this = $(this);
	      var tabPanel = $this.attr('aria-controls');
	      toggleTab(tabPanel);
	    });
	
	    // Dropdown menu for mobile
	    flashSaleDropDownTrigger.on('click', function() {
	      var currentDropdownSate = flashSaleDropDownMenu.attr('aria-hidden') === 'false' ? false : true;
	      flashSaleDropDownMenu.attr('aria-hidden', !currentDropdownSate);
	      flashSaleDropDown.toggleClass('is-visible');
	    });
	
	    // Dropdown Items
	    flashSaleMenuItem.on('click', function(e) {
	      e.preventDefault();
	
	      var $this = $(this);
	      var text = $this.text();
	      var value = $this.data('value');
	      var tabPanel = $this.data('tabpanel');
	
	      flashSaleDropDownTrigger.text(text);
	      flashSaleDropDown.removeClass('is-visible');
	
	      toggleTab(tabPanel);
	    });
	
	    // Show more button
	    flashSaleShowMore.on('click', function(e) {
	      e.preventDefault();
	      var $this = $(this);
	      var category = $this.data('category');
	      var container = $('.js-flashSale__' + category);
	
	      if (!$this.hasClass('is-hidden')) {
	        container.find('.flashSale__dealItem').each(function () {
	          $(this).removeClass('is-hidden');
	        });
	        container.find('.js-showMoreButton').addClass('is-hidden');
	      }
	    });
	
	    if (hash !== '') {
	      var tabWithHash = $('.js-flashSale__tab' + hash + '-tabitem');
	      var dropdownItemWithHash = $('.js-flashSale__menuItem' + hash + '-menuitem');
	
	      if (tabWithHash.length > 0) {
	        tabWithHash.trigger('click');
	      }
	      if (dropdownItemWithHash.length > 0) {
	        dropdownItemWithHash.trigger('click');
	      }
	
	      resetUrl();
	    } else {
	      currentOpenTab.click();
	    }
	  });
	})();


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// flashsale.bundle.min.js